var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcGraphic = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m497 482h-467v-467c0-8.291-6.709-15-15-15s-15 6.709-15 15v482c0 8.291 6.709 15 15 15h482c8.291 0 15-6.709 15-15s-6.709-15-15-15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75 452h61c8.291 0 15-6.709 15-15v-91c0-8.291-6.709-15-15-15h-61c-8.291 0-15 6.709-15 15v91c0 8.291 6.709 15 15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m196 271c-8.291 0-15 6.709-15 15v151c0 8.291 6.709 15 15 15h60c8.291 0 15-6.709 15-15v-151c0-8.291-6.709-15-15-15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m316 211c-8.291 0-15 6.709-15 15v211c0 8.291 6.709 15 15 15h60c8.291 0 15-6.709 15-15v-211c0-8.291-6.709-15-15-15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m497 151h-61c-8.291 0-15 6.709-15 15v271c0 8.291 6.709 15 15 15h61c8.291 0 15-6.709 15-15v-271c0-8.291-6.709-15-15-15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.787 263.104c3.959 7.359 13.109 9.994 20.317 6.108l349.287-187.538-8.809 17.617c-3.706 7.412-.703 16.421 6.709 20.127 7.48 3.713 16.436.652 20.127-6.709l30-60c2.329-4.644 2.08-10.166-.659-14.59s-7.559-7.119-12.759-7.119h-75c-8.291 0-15 6.709-15 15s6.709 15 15 15h15.5l-338.604 181.787c-7.295 3.941-10.035 13.037-6.109 20.317z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcGraphic, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-graphic.42c7e5f2.svg";
export { ForwardRef as ReactComponent };